var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('no-results',{attrs:{"title":`Site unavailable`,"message":_vm.message,"cta":{ label: 'Go back', class: 'is-outlined', icon: 'arrow-left' },"icon":"exclamation-triangle"},on:{"click":function($event){return _vm.$router.go(-1)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }